import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "sticky top-0 bg-white shadow-md z-50" }
const _hoisted_2 = { class: "bg-white shadow-md font-roboto relative z-40" }
const _hoisted_3 = { class: "max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4 sticky" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", {
  href: "/landing",
  class: "flex items-center space-x-3 rtl:space-x-reverse"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/img/logos/GetGo_Home_Logo.png",
    class: "h-16 hidden lg:block",
    alt: "GetGo Logo"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: "/img/logos/GetGo_Home_Logo.png",
    class: "h-9 block lg:hidden",
    alt: "GetGo Logo"
  })
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5",
  "aria-hidden": "true",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 14"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M1 1h15M1 7h15M1 13h15"
  })
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  class: "hidden w-full lg:block md:w-auto",
  id: "navbar-solid-bg"
}
const _hoisted_8 = { class: "flex flex-col items-baseline font-medium mt-4 rounded-lg md:space-x-8 rtl:space-x-reverse md:flex-row md:mt-0 md:border-0" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("a", {
  href: "/profile",
  class: "block py-2 px-3 md:p-0 rounded text-grey-blue group relative"
}, " My Profile ", -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("a", {
  href: "/my-donations",
  class: "block py-2 px-3 md:p-0 rounded text-grey-blue group relative"
}, " My Donations ", -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { key: 2 }
const _hoisted_16 = ["href"]
const _hoisted_17 = { class: "py-2 px-3 md:p-0 rounded flex items-baseline text-grey-blue cursor-pointer" }
const _hoisted_18 = {
  key: 0,
  class: "absolute top-full left-0 bg-white shadow-md mt-2 py-2 w-40 z-10 rounded-lg"
}
const _hoisted_19 = ["href"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("a", {
  href: "/register/school",
  class: "block py-2 px-3 md:p-0 rounded text-grey-blue"
}, " Register My School ", -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("a", {
  href: "/add-campaign",
  class: "font-roboto text-white text-sm uppercase bg-pink py-2 px-4 rounded-md block"
}, " Create Campaign ", -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { class: "p-4" }
const _hoisted_25 = { class: "mb-5 pl-3" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "text-dark-blue text-base font-semibold" }
const _hoisted_28 = {
  key: 0,
  class: "text-gray-500 mt-1 text-sm"
}
const _hoisted_29 = {
  key: 1,
  class: "text-gray-500 mt-1 text-sm"
}
const _hoisted_30 = {
  key: 2,
  class: "text-gray-500 mt-1 text-sm"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("hr", { class: "bg-gray-500 w-full mt-3" }, null, -1)
const _hoisted_32 = { key: 1 }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("img", {
  src: "/img/GetGo_Logo_Small.svg",
  alt: "GetGo Logo"
}, null, -1)
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = {
  key: 0,
  class: "bg-gray-500 w-full my-3"
}
const _hoisted_36 = ["href", "onClick"]
const _hoisted_37 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_tippy = _resolveComponent("vue-tippy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.sidebarOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.toggleSidebar && $options.toggleSidebar(...args))),
          class: "fixed inset-0 bg-black opacity-30 z-30"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($options.toggleSidebar && $options.toggleSidebar(...args))),
          "data-collapse-toggle": "navbar-solid-bg",
          type: "button",
          class: "inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-grey-blue rounded-lg lg:hidden",
          "aria-controls": "navbar-solid-bg",
          "aria-expanded": "false"
        }, _hoisted_6),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("ul", _hoisted_8, [
            ($setup.user && !$setup.getgoAdmin && !$setup.schoolAdmin)
              ? (_openBlock(), _createElementBlock("li", _hoisted_9, _hoisted_11))
              : _createCommentVNode("", true),
            ($setup.user && !$setup.getgoAdmin && !$setup.schoolAdmin)
              ? (_openBlock(), _createElementBlock("li", _hoisted_12, _hoisted_14))
              : _createCommentVNode("", true),
            ($setup.getgoAdmin || $setup.schoolAdmin)
              ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
                  _createElementVNode("a", {
                    href: $setup.dashboardRedirectUrl,
                    class: "block py-2 px-3 md:p-0 rounded text-grey-blue group relative"
                  }, " Dashboard ", 8, _hoisted_16)
                ]))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("li", null, [
              _createElementVNode("div", {
                class: "relative",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.toggleDropdown && $setup.toggleDropdown(...args)))
              }, [
                _createElementVNode("a", _hoisted_17, [
                  _createTextVNode(" Learn More "),
                  _createElementVNode("img", {
                    class: _normalizeClass(["ml-2 transition-transform", { 'rotate-180': $setup.dropdownOpen }]),
                    src: "/img/Down_Arrow_Navbar.svg",
                    alt: "Down Arrow"
                  }, null, 2)
                ]),
                ($setup.dropdownOpen)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_18, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.dropdownItems, (item, index) => {
                        return (_openBlock(), _createElementBlock("li", { key: index }, [
                          _createElementVNode("a", {
                            href: item.href,
                            class: "block px-4 py-2 text-grey-blue hover:bg-[#DBEAFE]"
                          }, _toDisplayString(item.name), 9, _hoisted_19)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 512), [
              [_vShow, !_ctx.$keycloak.authenticated || (_ctx.$keycloak.authenticated && (!$setup.schoolAdmin && !$setup.getgoAdmin))]
            ]),
            _withDirectives(_createElementVNode("li", null, _hoisted_21, 512), [
              [_vShow, !_ctx.$keycloak.authenticated || (_ctx.$keycloak.authenticated && (!$setup.schoolAdmin && !$setup.getgoAdmin))]
            ]),
            _withDirectives(_createElementVNode("li", null, _hoisted_23, 512), [
              [_vShow, !_ctx.$keycloak.authenticated || (_ctx.$keycloak.authenticated && (!$setup.getgoAdmin))]
            ]),
            _withDirectives(_createElementVNode("li", null, [
              _createVNode(_component_vue_tippy),
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($options.donate && $options.donate(...args))),
                class: "font-roboto font-bold text-dark-blue text-sm uppercase bg-bright-green py-2 px-4 rounded-md group relative"
              }, " Donate Now ")
            ], 512), [
              [_vShow, !_ctx.$keycloak.authenticated || (_ctx.$keycloak.authenticated && (!$setup.schoolAdmin && !$setup.getgoAdmin))]
            ]),
            _createElementVNode("li", null, [
              (!_ctx.$keycloak.authenticated)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($options.login && $options.login(...args))),
                    class: "font-roboto font-normal text-white uppercase text-sm bg-dark-blue py-2 px-4 rounded-md group relative"
                  }, " Login "))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($options.logout && $options.logout(...args))),
                    class: "font-roboto font-normal text-white uppercase text-sm bg-dark-blue py-2 px-4 rounded-md group relative"
                  }, " Log Out "))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([{ 'translate-x-0': $setup.sidebarOpen, 'translate-x-full': !$setup.sidebarOpen}, "fixed inset-y-0 right-0 z-40 mt-16 bg-white w-64 shadow-lg transform transition-transform duration-300 ease-in-out lg:hidden overflow-y-auto"])
    }, [
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          (_ctx.$keycloak.authenticated)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.$keycloak.tokenParsed?.given_name) + " " + _toDisplayString(_ctx.$keycloak.tokenParsed?.family_name), 1),
                ($setup.getgoAdmin)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_28, "GetGo Admin"))
                  : _createCommentVNode("", true),
                ($setup.schoolAdmin)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_29, "School Admin"))
                  : _createCommentVNode("", true),
                ($setup.user && !$setup.getgoAdmin && !$setup.schoolAdmin)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_30, "User"))
                  : _createCommentVNode("", true),
                _hoisted_31
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_32, _hoisted_34))
        ]),
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.navigation, (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              class: "mb-3"
            }, [
              (item.name === 'My Profile')
                ? (_openBlock(), _createElementBlock("hr", _hoisted_35))
                : _createCommentVNode("", true),
              _createElementVNode("a", {
                href: item.href,
                class: "flex items-center py-2 px-3 rounded hover:bg-[#DBEAFE]",
                onClick: ($event: any) => (item.name === 'Log In' ? $options.login() : (item.name === 'Log Out' ? $options.logout() : null))
              }, [
                _createElementVNode("img", {
                  src: `/img/Icons/${item.icon}.svg`,
                  class: "h-5 mr-2",
                  alt: "Icon"
                }, null, 8, _hoisted_37),
                _createTextVNode(" " + _toDisplayString(item.name), 1)
              ], 8, _hoisted_36)
            ]))
          }), 128))
        ])
      ])
    ], 2)
  ]))
}